<script lang="ts">
    import { Image } from "sveltestrap";
    import { New, Today, UpdatedProducts } from "../../../utils/Constant/Constant";
    let imgPath:string = "../assets/images/dashboard-2"
</script>

<div class="media">
    <div class="activity-dot-primary" />
    <div class="media-body d-block">
        <h6>
            <span class="font-primary">20-04-2021</span>{Today}<span
                class="badge pill-badge-primary m-l-10"
                >{New}
            </span>
        </h6>
        <h5>
            James just like your product <i
                class="fa fa-circle circle-dot-primary pull-right"
            />
        </h5>
        <p>{UpdatedProducts}</p>
        <ul class="timeline-pro">
            <li>
                <Image
                    fluid
                    src="{imgPath}/11.png"
                    alt="Product-1"
                />
            </li>
            <li>
                <Image
                    src="{imgPath}/10.png"
                    alt="Product-2"
                />
            </li>
        </ul>
    </div>
</div>
